import React from "react";
import Icon from "@ant-design/icons";
import { Spin as AntdSpin } from "antd";
import { cx } from "@emotion/css";
import { MappedSizeDefault } from "@type/sizing";
import { getLoader } from "./core/components/defaultSvg";
import { loaderClass, StyledContent } from "./loader.styles";
import { LoaderProps } from "./loader.types";

const sizeMapping = {
    medium: "48px",
    small: "32px",
    large: "56px",
};

export const Loader = ({
    children,
    size = "medium",
    className,
    ...rest
}: LoaderProps) => {
    return (
        <AntdSpin
            indicator={<Icon spin component={getLoader(sizeMapping[size])} />}
            size={MappedSizeDefault[size]}
            className={cx(loaderClass, className)}
            {...rest}
        >
            {children ?? <StyledContent />}
        </AntdSpin>
    );
};

Loader.displayName = "Loader";
